import Modal from '../common/Modal';
import ProjectForm from './forms/ProjectForm';
import InspectionForm from './forms/InspectionForm';
import NCRForm from './forms/NCRForm';
import RFIForm from './forms/RFIForm';
import DailyReportForm from './forms/DailyReportForm';
import DocumentForm from './forms/DocumentForm';
import MaterialForm from './forms/MaterialForm';
import PhotoForm from './forms/PhotoForm/photoUploadForm';
import SubmittalForm from './forms/SubmittalForm';

const MODAL_REGISTRY = {
  project: {
    title: 'New Project',
    component: ProjectForm
  },
  inspection: {
    title: 'New Inspection',
    component: InspectionForm
  },
  ncr: {
    title: 'Report NCR',
    component: NCRForm
  },
  rfi: {
    title: 'New RFI',
    component: RFIForm
  },
  'daily-report': {
    title: 'Daily Report',
    component: DailyReportForm
  },
  document: {
    title: 'Upload Document',
    component: DocumentForm
  },
  material: {
    title: 'Add Material',
    component: MaterialForm
  },
  photo: {
    title: 'Upload Photo',
    component: PhotoForm
  },
  submittal: {
    title: 'New Submittal',
    component: SubmittalForm
  }
};

const ModalManager = ({
  modalType,
  modalProps,
  onClose,
  onSubmit,
  isLoading
}) => {
  if (!modalType) return null;

  const modalConfig = MODAL_REGISTRY[modalType];
  if (!modalConfig) return null;

  const FormComponent = modalConfig.component;

  return (
    <Modal
      isOpen={true}
      title={modalConfig.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isLoading}
    >
      <FormComponent {...modalProps} onSubmit={onSubmit} />
    </Modal>
  );
};

export default ModalManager;
